module.exports = __webpack_public_path__ + "static/media/rhiza.91ed1ffd.jpg";